module.exports = __webpack_public_path__ + "static/tutorial-slide-4-6469093279db5b1312e431b1fbafa8a1.png";